import './Result.scss';

export const Result = ({ showLoader, children }) => {
  return (
    <section className='result border rounded p-4'>
      {showLoader ? (
        <div className='text-center'>
          <img src='../images/loader.gif' width='50' height='50' alt='loader' />
        </div>
      ) : (
        children
      )}
    </section>
  );
};
